// @ts-nocheck

/**
 * * `PENDING` - Pending payment
 * `PAID` - Paid (fulfilment pending)
 * `FULFILLED` - Fulfilled
 * `NEEDS_ATTENTION` - Paid, fulfilment failed (needs attention)
 * `FAILED` - Payment failed
 * `EXPIRED` - Checkout expired
 */
export type CheckoutOrderStatusEnum =
  typeof CheckoutOrderStatusEnum[keyof typeof CheckoutOrderStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CheckoutOrderStatusEnum = {
  PENDING: "PENDING",
  PAID: "PAID",
  FULFILLED: "FULFILLED",
  NEEDS_ATTENTION: "NEEDS_ATTENTION",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
} as const;
